import React from 'react';
import { Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { language } = useLanguage();
  const ru = language === 'ru';
  const lp = (p) => (ru ? '/ru' + p : p);

  const colProducts = [
    { label: ru ? 'Виртуальные серверы' : 'Virtual Servers', to: lp('/'), link: true },
    { label: 'VPN', to: lp('/vpn'), link: true },
    { label: ru ? 'Тарифы' : 'Pricing', to: '#pricing', link: false },
    { label: ru ? 'Дата-центры' : 'Datacenters', to: '#locations', link: false },
    { label: ru ? 'Снапшоты' : 'Snapshots', to: lp('/snapshots'), link: true },
    { label: 'API', to: lp('/developers'), link: true },
  ];
  const colCompany = [
    { label: ru ? 'База знаний' : 'Knowledge base', to: lp('/wiki'), link: true },
    { label: ru ? 'Поддержка' : 'Support', to: lp('/support'), link: true },
    { label: ru ? 'О нас' : 'About', to: lp('/about'), link: true },
    { label: ru ? 'Партнёрам' : 'Partners', to: lp('/affiliate'), link: true },
  ];
  const colLegal = [
    { label: ru ? 'Правовая информация' : 'Legal Information', to: lp('/legal'), link: true },
    { label: ru ? 'Сообщить о злоупотреблении' : 'Report Abuse', to: 'mailto:abuse-report@netgrid.host', link: false },
  ];

  const Col = ({ title, items }) => (
    <div>
      <h3 className="text-slate-200 text-sm font-semibold mb-4">{title}</h3>
      <ul className="space-y-3">
        {items.map((it, i) => (
          <li key={i}>
            {it.link ? (
              <Link to={it.to} className="text-slate-400 hover:text-blue-400 text-sm transition-colors">{it.label}</Link>
            ) : (
              <a href={it.to} className="text-slate-400 hover:text-blue-400 text-sm transition-colors">{it.label}</a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer style={{ background: '#0b1220', borderTop: '1px solid #1e293b' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-[1.8fr_1fr_1fr_1fr] gap-10">
          <div>
            <img alt="NetGrid Host" className="h-10 w-auto mb-4" src="/logo-horizontal-dark-animated.svg" />
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-5">
              {ru
                ? 'Премиальный VPS-хостинг по Европе и США. Серверное железо Supermicro, сеть 1 Гбит/с и поддержка 24/7.'
                : 'Premium VPS hosting across Europe and the US. Enterprise-grade Supermicro hardware, 1 Gbps network and 24/7 expert support.'}
            </p>
            <a href="https://t.me/NetGridHost" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors" style={{ background: 'rgba(96,165,250,.12)', border: '1px solid rgba(96,165,250,.3)', color: '#60a5fa' }}>
              <Send className="w-4 h-4" />
              {ru ? 'Telegram-канал' : 'Telegram channel'}
            </a>
          </div>
          <Col title={ru ? 'Продукты' : 'Products'} items={colProducts} />
          <Col title={ru ? 'Компания' : 'Company'} items={colCompany} />
          <Col title={ru ? 'Правовое' : 'Legal'} items={colLegal} />
        </div>
        <div className="mt-10 pt-7 text-center" style={{ borderTop: '1px solid #1e293b' }}>
          <p className="text-slate-500 text-sm">© 2026 NetGrid Host Ltd. {ru ? 'Все права защищены.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </footer>
  );
};
